import React from 'react';
import '../styles/resetsuccess.css';
import { useNavigate } from "react-router-dom";
import leftImage from '../assets/landing1.png';
import successIcon from '../assets/success.png'; // you can use your key.png or add a success icon

const ResetSuccess = () => {
  const handleLoginRedirect = () => {
  navigate("/login");
};
  const navigate = useNavigate();

  return (
    <div className="success-page">
      {/* Left Image Section */}
      <div className="left-side">
        <img src={leftImage} alt="Lingayath Weds" className="left-image" />
      </div>

      {/* Right Success Section */}
      <div className="right-side">
        <div className="success-card">
          <h1 className="title">Welcome to Lingayath Weds</h1>
          
          <div className="success-content">
            {/* Success Icon */}
            <div className="icon-container">
              <img src={successIcon} alt="Success" className="success-icon" />
            </div>
            
            {/* Success Message */}
            <p className="success-message">
              Your password has been reset successfully. Kindly proceed to the login page to access your account.
            </p>

            {/* Go to Login Button */}
            <button 
              type="button" 
              className="login-btn"
              onClick={handleLoginRedirect}
            >
              Go to Login Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetSuccess;